import React from "react";
import "./TextCTA.css";

interface TextCTAProps {
    text: string;
    hasIcon: boolean;
    iconPath?: string;
    onClick?: () => void;
}

function TextCTA({
    text,
    hasIcon = false,
    iconPath = "",
    onClick,
}: TextCTAProps) {
    return (
        <div className="text-cta">
            {hasIcon && <img src={iconPath}></img>}

            <button onClick={onClick}>{text}</button>
        </div>
    );
}

export default TextCTA;
